import { Moment } from 'moment';

import { VehicleOfficeSearchViewModel } from '@api/index';

export interface ICarRentalErrors {
  pickUpLocation: boolean;
  dropOffLocation: boolean;
  pickUpDate: boolean;
  dropOffDate: boolean;
  pickUpTime: boolean;
  dropOffTime: boolean;
}

export interface ICarRentalAutoComplateViewModel {
  airportId: number;
  airportCode: string;
  airportName: string;
  cityCode: string;
  cityName: string;
  countryCode: string;
  countryName: string;
  isCity: boolean;
}

export type CarRentalLocationType = VehicleOfficeSearchViewModel | null;
export interface ICarRentalSearchBarState {
  pickUpLocation: CarRentalLocationType;
  dropOffLocation: CarRentalLocationType;
  pickUpDate: Moment | null;
  dropOffDate: Moment | null;
  pickUpTime: string;
  dropOffTime: string;
  errors: ICarRentalErrors;
  isDifferentLocation: boolean;
}

export enum CarRentalSearchBarActionType {
  SET_PICK_UP_LOCATION = 'SetCarPickUpLocation',
  SET_DROP_OFF_LOCATION = 'SetCarDropOffLocation',
  SET_PICK_UP_DATE = 'SetCarPickUpDate',
  SET_DROP_OFF_DATE = 'SetCarDropOffDate',
  SET_PICK_UP_TIME = 'SetCarPickUpTime',
  SET_DROP_OFF_TIME = 'SetCarDropOffTime',
  SET_IS_DIFFERENT_LOCATION = 'SetCarDifferentLocation',
  SET_ALL = 'SetCarAll',
  SET_ERROR = 'SetCarError',
}

export interface SetPickUpLocation {
  type: CarRentalSearchBarActionType.SET_PICK_UP_LOCATION;
  payload: ICarRentalSearchBarState['pickUpLocation'];
}

export interface SetDropOffLocation {
  type: CarRentalSearchBarActionType.SET_DROP_OFF_LOCATION;
  payload: ICarRentalSearchBarState['dropOffLocation'];
}

export interface SetErrors {
  type: CarRentalSearchBarActionType.SET_ERROR;
  payload: ICarRentalSearchBarState['errors'];
}

export interface SetPickUpDate {
  type: CarRentalSearchBarActionType.SET_PICK_UP_DATE;
  payload: ICarRentalSearchBarState['pickUpDate' | 'dropOffDate'];
}

export interface SetDropOffDate {
  type: CarRentalSearchBarActionType.SET_DROP_OFF_DATE;
  payload: ICarRentalSearchBarState['dropOffDate'];
}

export interface SetPickUpTime {
  type: CarRentalSearchBarActionType.SET_PICK_UP_TIME;
  payload: ICarRentalSearchBarState['pickUpTime' | 'dropOffTime'];
}

export interface SetDropOffTime {
  type: CarRentalSearchBarActionType.SET_DROP_OFF_TIME;
  payload: ICarRentalSearchBarState['dropOffTime'];
}

export interface SetIsDifferentLocation {
  type: CarRentalSearchBarActionType.SET_IS_DIFFERENT_LOCATION;
  payload: ICarRentalSearchBarState['isDifferentLocation'];
}

export interface SetCarRentaAll {
  type: CarRentalSearchBarActionType.SET_ALL;
  payload: ICarRentalSearchBarState;
}

export type CarSearchBarActions =
  | SetPickUpLocation
  | SetDropOffLocation
  | SetPickUpDate
  | SetDropOffDate
  | SetPickUpTime
  | SetDropOffTime
  | SetCarRentaAll
  | SetIsDifferentLocation
  | SetErrors;
